import React, { Component } from 'react';
import { Rect, Text } from 'react-konva';
import { isDevelopment, strokeWidth,} from '../../library/constants';
import { isMobilePhone, isMobileTablet } from '../../library/calc';

const adjustTopStandardTree = -3;
const adjustLeftStandardTree = 32;
const standardTreeWidth = 6;
const standardTreeHeight = 5;

const adjustTopPedigreeTree = 8;
const adjustLeftPedigreeTree = 66;
const pedigreeTreeWidth = 4;
const pedigreeTreeHeight = 9;

let size = {};


let killToolTip = false;

export const TextRectangle = ({
    node,
    nm,
    pr_id,
    left,
    top,
    onClickedInvite,
    stopStageClickPropagation,
    cursorBecomesMove,
    cursorBecomesPointer,
    userTouchedNode,
    setFlipCardScreenIsOn,
    setNodeForFlipFocus,
    setShowMobileFlipCard,
    setCurZoomScaleWhenClicked,
    isPedigree,
  }) => {


  left += ( !isPedigree ? adjustLeftStandardTree: adjustLeftPedigreeTree);
  top += (!isPedigree ? adjustTopStandardTree: adjustTopPedigreeTree) - 2;

  size = {
    width: (!isPedigree ? standardTreeWidth: pedigreeTreeWidth),
    height: ( !isPedigree ? standardTreeHeight: pedigreeTreeHeight)
  };

  return <Rect
    x={left}
    y={top}
    width={size.width}
    height={size.height}
    cursor="pointer"
    fill={`${ !isPedigree ? 'green': '#75B775'}`}

    strokeWidth={( !isPedigree ? undefined : strokeWidth)}
    stroke = {( !isPedigree ? undefined : '#288B2E')}
    cornerRadius={(!isPedigree ? 0 : 0)}

    onClick={(evt)=>{
      evt.cancelBubble = true;
      killToolTip = true;
      setTimeout(() => {
        killToolTip = false;
      }, 800);
      stopStageClickPropagation({fromWhere:'multiple parents A'});
      killToolTip = true;
      if(!isDevelopment ){
        setCurZoomScaleWhenClicked();
        window.openParentChooser(pr_id);
      } else{
        alert('You are on Dev.')
      }
    }}

    onTouchStart={()=>{

      stopStageClickPropagation({fromWhere:'multiple parents B'});
      userTouchedNode({
        node,
        callback: ()=>{
          if(isMobileTablet()){
            window.openParentChooser(pr_id);
          }
          if(isMobilePhone()) {

            const screenIsOn = `parentChooserFormFromTree`;
            setFlipCardScreenIsOn({screenIsOn});
            setNodeForFlipFocus(node);
            setShowMobileFlipCard(node);

            if(!isDevelopment){
              setTimeout(() => {
                window.openParentChooser(pr_id);
              }, 700);
            }

          };
        },
        fromWhere: 'parentChooser container'
      });

    }}

  />;
};



export const Label = ({
    node,
    pr_id,
    nm,
    npu,
    left,
    top,
    onClickedInvite,
    stopStageClickPropagation,
    cursorBecomesMove,
    cursorBecomesPointer,
    userTouchedNode,
    setFlipCardScreenIsOn,
    setNodeForFlipFocus,
    setShowMobileFlipCard,
    setCurZoomScaleWhenClicked,
    hideToolTip,
    showToolTipFor,
    translatedPhrases,
    isPedigree,
    pedigreeIsTall,
  }) => {

    left += ( !isPedigree ? adjustLeftStandardTree: adjustLeftPedigreeTree);
    top += (!isPedigree ? adjustTopStandardTree: (adjustTopPedigreeTree + 1.9)) - 1;

    size = {
      width: (!isPedigree ? standardTreeWidth: pedigreeTreeWidth),
      height: ( !isPedigree ? standardTreeHeight: pedigreeTreeHeight)
    };

    return <Text
      x={left}
      y={top}
      text={npu}
      fontSize={3.5}
      fill='white'
      align='center'
      width={size.width}

      onClick={(evt)=>{
        killToolTip = true;
        setTimeout(() => {
          killToolTip = false;
        }, 800);
        evt.cancelBubble = true;
        stopStageClickPropagation({fromWhere:'multiple parents C'});
        if(!isDevelopment ){
          setCurZoomScaleWhenClicked();
          window.openParentChooser(pr_id);
        } else{
          alert('You are on Dev.')
        }
      }}

      onTouchStart={()=>{

        stopStageClickPropagation({fromWhere:'multiple parents B'});
        userTouchedNode({
          node,
          callback: ()=>{
            if(isMobileTablet()){
              if(typeof(window.openParentChooser) !== 'undefined') window.openParentChooser(pr_id);
            }
            if(isMobilePhone()) {

              const screenIsOn = `parentChooserFormFromTree`;
              setFlipCardScreenIsOn({screenIsOn});
              setNodeForFlipFocus(node);
              setShowMobileFlipCard(node);

              if(!isDevelopment){
                setTimeout(() => {
                  window.openParentChooser(pr_id);
                }, 700);
              }

            };
          },
          fromWhere: 'parentChooser text'
        });

      }}

      onMouseenter={()=>{
        cursorBecomesPointer();
        if(!killToolTip) {
          // console.log('onMouseover');
          // const phrase = `${translatedPhrases({nm})["{profile} appears mulitple times in this tree. Click this icon to move to {profile}'s next position in the tree."].translatedPhrase}`;
          // if(isDevelopment) { console.log('You are on dev.'); return; }

          let shift = {};

          if(!isPedigree){
            shift = {
              left: 28.7,
              top: 0,
            }
          } else {
            shift = {
              left: 62,
              top: 11,
            }
          }

          showToolTipFor({
            node,
            placement: 'over',
            shiftLeftOnToolTip: shift.left,
            shiftTopOnToolTip: shift.top,
            content: "{profile} has multiple sets of parents. Click this icon to choose which to show in the tree view.",
            runTranslatePhraseInToolTip: true,
            translateVarStrInToolTip: nm,
          })
        }
      }}
      onMouseleave={()=>{
        // console.log('mouse is leaving multiple parents component....');
        hideToolTip();
        cursorBecomesMove();
      }}
    />;
  };


export class TransparentTouchBox extends Component {

  render () {

    let {
      left,
      top,
    } = this.props;

    const  {
      node,
      pr_id,
      stopStageClickPropagation,
      userTouchedNode,
      setFlipCardScreenIsOn,
      setNodeForFlipFocus,
      setShowMobileFlipCard,
      isPedigree,
    } = this.props;


    left += ( !isPedigree ? adjustLeftStandardTree: adjustLeftPedigreeTree) - 3;
    top += (!isPedigree ? adjustTopStandardTree: (adjustTopPedigreeTree + 3)) - 7;

    let anotherSize = {
      width: (!isPedigree ? 12: 8),
      height: ( !isPedigree ? 10: 12)
    };

/*
            strokeWidth={.5}
            stroke = {'black'}
 */
    return  <Rect
              x={left}
              y={top}
              width={anotherSize.width}
              height={anotherSize.height}
              cursor="pointer"
              fill="transparent"
              onTouchStart={()=>{

                stopStageClickPropagation({fromWhere:'multiple parents B'});
                userTouchedNode({
                  node,
                  callback: ()=>{
                    if(isMobileTablet()){
                      if(typeof(window.openParentChooser) !== 'undefined') window.openParentChooser(pr_id);
                    }
                    if(isMobilePhone()) {

                      const screenIsOn = `parentChooserFormFromTree`;
                      setFlipCardScreenIsOn({screenIsOn});
                      setNodeForFlipFocus(node);
                      setShowMobileFlipCard(node);
                      if(!isDevelopment){
                        setTimeout(() => {
                          window.openParentChooser(pr_id);
                        }, 700);
                      }

                    };
                  },
                  fromWhere: 'parentChooser container'
                });

              }}


          />

  }
}

